import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEmailTemplate } from "../interface/emails/IEmailTemplate";
import { generateQueryString } from "src/util/helper";

enum BoilerplateEmailEnum {
  getAllTemplatesEmail = "/get-all",
  getTemplateById = "/get-by-id",
  saveOrUpdateTemplateEmail = "/save-or-update"
}

export default class BoilerplateEmailService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/boilerplate-email");
  }

  public getAllTemplates = async (): Promise<IEmailTemplate[]> => await this.GET(BoilerplateEmailEnum.getAllTemplatesEmail);
  public getTemplateById = async (id: number): Promise<IEmailTemplate> => await this.GET(`${BoilerplateEmailEnum.getTemplateById}?${generateQueryString({ id })}`);
  public saveOrUpdateTemplateEmail = async (template: Omit<IEmailTemplate, "id">): Promise<void> => await this.POST(BoilerplateEmailEnum.saveOrUpdateTemplateEmail, template);
}
